import Axios from '../axios.js'

/**
 * 工单组接口
 */
export default {
	/**
	 * 获取工单组结构树
	 */
	loadTree: (success, failure) => {
		Axios.post('/orderGroup/loadTree.do', {}, success, failure);
	},
	/**
	 * 添加工单组
	 */
	addOrderGroup: (name, priorityString, parentId, sort, success, failure) => {
		Axios.post('/orderGroup/addOrderGroup.do', {
			name,
			priorityString,
			parentId,
			sort
		}, success, failure);
	},
	/**
	 * 更新工单组
	 */
	updateOrderGroup: (groupId,name, priorityString, success, failure) => {
		Axios.post('/orderGroup/updateOrderGroup.do', {
			groupId,name, priorityString,
		}, success, failure);
	},
	/**
	 * 刪除工单组(子组同时删除)
	 */
	deleteOrderGroup: (groupId, success, failure) => {
		Axios.post('/orderGroup/deleteOrderGroup.do', {
			groupId
		}, success, failure);
	},
}
